// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Particle_Css = require("../design-system/particle/Particle_Css.bs.js");
var Particle_Screen_Ds = require("../design-system/particle/Particle_Screen_Ds.bs.js");

var heightStyle = Particle_Screen_Ds.make(undefined, undefined, Particle_Css.pxToRem(56), undefined, undefined, Particle_Css.pxToRem(40));

var Constants_height = {
  m: 56,
  default: 40
};

var Constants = {
  height: Constants_height,
  heightStyle: heightStyle,
  verticalPadding: 5
};

exports.Constants = Constants;
/* heightStyle Not a pure module */
